document.addEventListener("DOMContentLoaded", function(){

    var alltabs=document.querySelectorAll(".collection__v2--tab");
    
    alltabs.forEach(function(ele){
      ele.addEventListener("click", function(){
        var mainallt=document.querySelectorAll(".collection__v2--tab");
        mainallt.forEach(function(ele){
          ele.classList.remove("active");
        })
        ele.classList.add("active");
        if(ele.classList.contains("active")){
          var colmatch=ele.getAttribute("data-match");
        }
        
        var allcolls=document.querySelectorAll(".col__main--v2");
        allcolls.forEach(function(ele){
          var colattribute=ele.getAttribute("data-collection");
  
          if (colattribute === colmatch){
            ele.classList.add("active");
          }
          else{
            ele.classList.remove("active")
          }
        })
      })
    })
  })